import script from "./TarjetaInscripcion.vue?vue&type=script&setup=true&lang=ts"
export * from "./TarjetaInscripcion.vue?vue&type=script&setup=true&lang=ts"

import "./TarjetaInscripcion.vue?vue&type=style&index=0&id=18025a02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18025a02"]])

export default __exports__